import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { tooltipTrigger } from './trigger.vanilla.mjs';

const TooltipTrigger = forwardRef(
  ({ className: classNameFromProps, transparent, onFocus, ...props }, forwardedRef) => {
    const className = classNames(
      tooltipTrigger({ transparent }),
      classNameFromProps
    );
    const handleFocus = composeEventHandlers(onFocus, (event) => {
      if (event.relatedTarget === null) {
        event.preventDefault();
      }
    });
    return /* @__PURE__ */ jsx(
      TooltipPrimitive.Trigger,
      {
        "data-scope": "tooltip",
        "data-part": "trigger",
        className,
        onFocus: handleFocus,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
TooltipTrigger.displayName = "Tooltip.Trigger";

export { TooltipTrigger };
//# sourceMappingURL=Trigger.mjs.map
